import * as React from "react";
import { editType } from "../Settings/EditType";
import { SelectionGroup } from "../SharedReact/BasicElements";
export class EditPanel extends React.Component {
    constructor(props) {
        super(props);
        this._snapTypeChanged = this._snapTypeChanged.bind(this);
        this._lengthTypeChanged = this._lengthTypeChanged.bind(this);
        this._lengthEnabledChanged = this._lengthEnabledChanged.bind(this);
        this.state = {
            selectedSnapButton: editType.snapType,
            selectedLengthButton: editType.noteLength,
            lengthEnabled: editType.noteLengthDisabled
        };
    }
    componentDidMount() {
        editType.noteLengthDisabledChange.addListener(this._lengthEnabledChanged);
    }
    componentWillUnmount() {
        editType.noteLengthDisabledChange.removeListener(this._lengthEnabledChanged);
    }
    _snapTypeChanged(index) {
        this.setState({ selectedSnapButton: index });
        editType.snapType = index;
    }
    _lengthTypeChanged(index) {
        this.setState({ selectedLengthButton: index });
        editType.noteLength = index;
    }
    _lengthEnabledChanged(value) {
        this.setState({ lengthEnabled: value });
    }
    render() {
        return React.createElement("div", { className: "editPanel" },
            React.createElement("div", { className: "selectionGroup" },
                React.createElement("p", { className: "selectionGroupTitle" }, "Snap Type:"),
                React.createElement(SelectionGroup, { className: "snapTypeGroup", buttonClassName: "panelButton buttonAnim", disabled: false, selectedButton: this.state.selectedSnapButton, buttonContents: ["1", React.createElement(Fraction, { n: 1, d: 2 }), React.createElement(Fraction, { n: 1, d: 4 }), React.createElement(Fraction, { n: 1, d: 8 }), React.createElement("p", null, "\u2716")], buttonTitles: ["Snap to Whole Beat", "Snap To Half Beat", "Snap To Quarter Beat", "Snap to Eighth Beat", "No Snapping"], onButtonClick: this._snapTypeChanged })),
            React.createElement("div", { className: "selectionGroup" },
                React.createElement("p", { className: "selectionGroupTitle" }, "Note Length:"),
                React.createElement(SelectionGroup, { className: "lengthTypeGroup", buttonClassName: "panelButton buttonAnim noteButton", disabled: this.state.lengthEnabled, selectedButton: this.state.selectedLengthButton, buttonContents: [React.createElement("span", null, "\uD834\uDD5D"), React.createElement("span", null, "\uD834\uDD5E"), React.createElement("span", null, "\uD834\uDD5F"), React.createElement("span", null, "\uD834\uDD60"), React.createElement("span", null, "\uD834\uDD61"), React.createElement("span", null, "\uD834\uDD62")], buttonTitles: ["Whole Note", "Half Note", "Quarter Note", "8th Note", "16th Note", "32nd Note"], onButtonClick: this._lengthTypeChanged })));
    }
}
class Fraction extends React.PureComponent {
    render() {
        return React.createElement("p", { style: { fontFamily: "Arial, Helvetica, sans-serif" } },
            React.createElement("sup", null, this.props.n),
            "\u2044",
            React.createElement("sub", null, this.props.d));
    }
}
//# sourceMappingURL=EditPanel.js.map